import Image from "next/image";
import { iconMap } from "../../../public/index";

import { NoImageSVG } from "../../assets/favicons";

interface DynamicIconProps {
  iconName: string; // Icon name from the server
  color?: string;
  width?: string;
  height?: string;
}

const DynamicIcon: React.FC<DynamicIconProps> = ({
  iconName,
  color,
  width,
  height,
}) => {
  if (iconName?.includes("https://") || iconName?.includes("http://")) {
    return (
      <Image
        src={iconName}
        width={Number(width) || 4}
        height={Number(height) || 4}
        alt="Icon"
      />
    );
  }
  const IconComponent = iconMap[iconName];

  if (!IconComponent) {
    return (
      <NoImageSVG
        color={color || ""}
        width={width || ""}
        height={height || ""}
      />
    );
  }

  return (
    <IconComponent
      color={color || ""}
      width={width || ""}
      height={height || ""}
    />
  );
};

export default DynamicIcon;
